import { Controller } from '@hotwired/stimulus';
import { whenGlideReady } from 'controllers/carousel_controller';

// Product media gallery: a main Glide carousel kept in sync with a thumbnail
// slider. Both are destroyed before Turbo caches the page, so snapshots keep
// pristine markup (no clones, no stale transforms).
export default class extends Controller {
  static targets = ['thumbs', 'thumb'];

  connect() {
    this.teardown = this.teardown.bind(this);
    document.addEventListener('turbo:before-cache', this.teardown);
    whenGlideReady(() => this.mount());
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.teardown);
    this.teardown();
  }

  mount() {
    if (this.main || !this.element.isConnected) return;

    this.main = new Glide(this.element, {
      type: 'carousel',
      gap: 0,
      perView: 1,
    });

    this.thumbsSlider =
      this.hasThumbsTarget && this.thumbTargets.length > 1
        ? new Glide(this.thumbsTarget, {
            type: 'slider',
            gap: 12,
            perView: 4.5,
          })
        : null;

    this.main.on(['mount.after', 'run'], () => this.syncThumbs());

    if (this.thumbsSlider) {
      this.thumbsSlider.mount();
    }

    this.main.mount();
    this.syncThumbs();
  }

  teardown() {
    if (this.thumbsSlider) {
      this.thumbsSlider.destroy();
      this.thumbsSlider = null;
    }

    if (this.main) {
      this.main.destroy();
      this.main = null;
    }
  }

  goTo(event) {
    if (!this.main) return;

    this.main.go(`=${event.params.index}`);
  }

  syncThumbs() {
    const index = typeof this.main.index === 'number' ? this.main.index : 0;

    this.thumbTargets.forEach((button, buttonIndex) => {
      button.classList.toggle('active', buttonIndex === index);
    });

    if (this.thumbsSlider && this.thumbsSlider.index !== index) {
      this.thumbsSlider.go(`=${index}`);
    }
  }
}
